import { NgIf } from '@angular/common';
import { Directive, inject, OnInit } from '@angular/core';
import { TradeStoreService } from './trade-store.service';
@Directive({
    selector: '[ifTradeStore]',
    standalone: true
})
export class IfTradeStoreDirective extends NgIf implements OnInit {
    private tradestoreService = inject(TradeStoreService);
    ngOnInit() {
        this.ngIf = this.check();
    }
    protected check(): boolean {
        return this.tradestoreService.isTradeStore();
    }
}
